// extracted by mini-css-extract-plugin
export default {"GlobalMapContainer":"GlobalMapPart_GlobalMapContainer__4Jwsh"};